import { ChartOptions } from "chart.js";
import { useEffect, useState } from "react";
import { Chart } from "react-chartjs-2";
import { Spinner } from "../../../components/Spinner";
import moment from "moment";

interface ProcedureChartProps {
    data: any;
}

export function TendersApplyChart({ data }: ProcedureChartProps) {
    const [typeData, setTypeData] = useState<any[]>([]);
    const [typeDataLine, setTypeDataLine] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    const averageChart = {
        datasets: [
            {
                data: typeData,
                label: "Aantal aanbestedingen",
                backgroundColor: "#00aaaa",
                order: 2,
            },
            {
                data: typeDataLine,
                label: "Aantal inschrijvingen",
                backgroundColor: "#ff4d72",
                borderColor: "#ff4d72",
                type: "line" as const,
                order: 1,
            },
        ],
    };

    const mixedOptions: ChartOptions = {
        plugins: {
            legend: {
                display: true,
            },
            title: {
                display: false,
            },
        },
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                top: 0,
                left: 10,
                right: 10,
                bottom: 0,
            },
        },
    };

    useEffect(() => {
        handleData();
    }, []);

    async function handleData() {
        const output = Object.entries(
            data.reduce((prev: any, label: any) => {
                // Parse the ISO date string correctly
                const year = new Date(label["Publicatiedatum"]).getFullYear().toString();
                prev[year] = prev[year] ? prev[year] + 1 : 1;
                return prev;
            }, {})
        )
            .map(([x, y]) => ({ x, y }))
            .sort((a: any, b: any) => Number(a.x) - Number(b.x)); // Sort by year ascending

        const filteredOutput = output.filter(
            (element) => element.x !== "NaN" && Number(element.x) >= 2020
        );

        setTypeData(filteredOutput);

        const outputLine = Object.entries(
            data.reduce((prev: any, label: any) => {
                const year = new Date(label["Publicatiedatum"]).getFullYear();
                prev[year] = prev[year]
                    ? label["Aantal inschrijvingen"] !== undefined
                        ? prev[year] + Number(label["Aantal inschrijvingen"])
                        : prev[year] + 1
                    : 1;
                return prev;
            }, {})
        )
            .map(([x, y]) => ({ x, y }))
            .sort((a: any, b: any) => Number(a.x) - Number(b.x)); // Sort by year ascending

        const filteredOutputLine = outputLine.filter(
            (element) => element.x !== "NaN" && Number(element.x) >= 2020
        );

        setTypeDataLine(filteredOutputLine);
        setLoading(false);
    }

    return loading ? (
        <Spinner />
    ) : (
        <Chart
            type="bar"
            className="w-full"
            data={averageChart}
            options={mixedOptions}
        />
    );
}
